import { FormCategory, FormTemplate, SearchType } from '@nrwl/rx-models';
import {
  RxListCompositeComponent,
  RxReactiveFormCompositeComponent,
  RxTextCompositeComponent,
  RxVideoCompositeComponent,
} from '@nrwl/rx-forms';

import { DialogsConfigService } from '../dialogs-config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Validators } from '@angular/forms';

// import { FormsValidatorsService } from './forms-validators.service';

@Injectable({
  providedIn: 'root',
})
export class TagsService extends DialogsConfigService {
  constructor() {
    super();
  }

  public NewTag(items$: Observable<any[]>) {
    return {
      component: RxListCompositeComponent,
      payload: {
        title: 'Add New Tag to',
        items$: items$,
        buttons: this.SubmitDismissButtons('Save'),
      },
    };
  }

  public NewTagGroup() {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'New Tag Group',
        placeholder: 'Tag Group',
        tip: 'All tags must belong to a tag group.',
        tipClose: false,
        buttons: this.SubmitDismissButtons(),
        fields: [
          {
            placeholder: 'Tag Group',
            labelText: null,
            hasInlineInfo: true,
            value: '',
            maxLength: 50,
          },
        ],
      },
    };
  }

  // TODO think about common service for bottom bar confirmation dialogs
  // remember that there is no multiple extends in TypeScript
  public deselectAllConfirmation() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: '[TODO Message]: Do you want to deselect all items?',
        tip: '[TODO Description]: Explanatory message for RWE-179',
        buttons: this.SubmitDismissButtons('Yes', 'No'),
      },
    };
  }

  public HelpCenter() {
    return {
      component: RxVideoCompositeComponent,
      payload: {
        title: 'Help Center',
        buttons: this.DismissButton(),
      },
    };
  }
}
